"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributionEventSchema = exports.AttributionEventFields = exports.ExternalAttributionEventFields = exports.AttributionEventKeywordSchema = exports.AttributionEventTokenSchema = exports.AttributionEventNameSchema = exports.castToAttributionProvider = exports.AttributionProviderTypeSchema = exports.AttributionProviderType = exports.AttributionSecretKeySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../core");
const cast_1 = require("../utils/cast");
const apple_1 = require("./apple");
const platform_1 = require("./platform");
exports.AttributionSecretKeySchema = typebox_1.Type.String({
    title: "Attribution Secret Key",
    description: "Token for attribution event submission",
    examples: ["a6f7a8c0-d857-4e8a-9c8c-819a49229d63"],
});
var AttributionProviderType;
(function (AttributionProviderType) {
    AttributionProviderType["ADJUST"] = "ADJUST";
    AttributionProviderType["APPSFLYER"] = "APPSFLYER";
    AttributionProviderType["REDBOX"] = "REDBOX";
    AttributionProviderType["BRANCH"] = "BRANCH";
    AttributionProviderType["SINGULAR"] = "SINGULAR";
    AttributionProviderType["KOCHAVA"] = "KOCHAVA";
})(AttributionProviderType = exports.AttributionProviderType || (exports.AttributionProviderType = {}));
exports.AttributionProviderTypeSchema = (0, core_1.StringUnion)([
    AttributionProviderType.ADJUST,
    AttributionProviderType.APPSFLYER,
    AttributionProviderType.REDBOX,
    AttributionProviderType.BRANCH,
    AttributionProviderType.SINGULAR,
    AttributionProviderType.KOCHAVA,
], {
    title: "Attribution provider",
    description: "The provider of the attribution event",
});
exports.castToAttributionProvider = (0, cast_1.castToEnum)(AttributionProviderType);
exports.AttributionEventNameSchema = typebox_1.Type.String();
exports.AttributionEventTokenSchema = typebox_1.Type.String();
exports.AttributionEventKeywordSchema = typebox_1.Type.String();
exports.ExternalAttributionEventFields = {
    provider: exports.AttributionProviderTypeSchema,
    name: exports.AttributionEventNameSchema,
    token: exports.AttributionEventTokenSchema,
    timestamp: core_1.TimestampSchema,
    installedAt: (0, core_1.Nullable)(core_1.TimestampSchema),
    clickedAt: (0, core_1.Nullable)(core_1.TimestampSchema),
    keyword: (0, core_1.Nullable)(exports.AttributionEventKeywordSchema),
    campaignRef: platform_1.PlatformCampaignRefSchema,
    deviceRef: (0, core_1.Nullable)(platform_1.PlatformDeviceRefSchema),
    adGroupRef: (0, core_1.Nullable)(apple_1.AppleProxyRefSchema),
    // Either AAID or IDFA (ID for Advertiser)
    aidRef: (0, core_1.Nullable)(platform_1.PlatformAidRefSchema),
    revenue: core_1.MoneySchema,
};
exports.AttributionEventFields = {
    campaignId: core_1.IdSchema,
    teamId: core_1.IdSchema,
    country: core_1.CountrySchema,
    ...exports.ExternalAttributionEventFields,
};
exports.AttributionEventSchema = (0, core_1.StrictObject)({
    ...exports.AttributionEventFields,
    ...core_1.ModelMetaFields,
}, {
    title: "Attribution event",
    description: "Event relating to attribution",
});
